import {
  getJsonAsync,
  navigateTo
} from 'shared/actions';
import {detectIE} from 'shared/util/detectIE';
import {
  setTopBannerImagePath,
  setTitle,
  setSubTitle
} from 'shared/topBanner/actionTypes';
import {
  displayGoHome
} from './accountCreated/actionTypes';
import {
  resetInformation,
  retrieveAvailableDates,
  updateTotalFromLocalStorage,
  retrieveVirtualEvents,
  checkRestrictions,
  handleDateSelection
} from './scheduler/actions';
import {
  retrieveCountries,
  retrieveStates,
  retrieveUserVirtualEntries,
  retrieveEntries
} from './shared/actions';
import {
  retrieveEntriesFromCart,
  retrieveVirtualEntriesFromCart,
  retrieveEvents
} from './rostercheckout/actions';
import {
  restoreLocalDataForCheckout,
  validateCart,
  retrieveTermsUrl,
  resetAgreeToTerms,
  resetValidationMesssages,
  processPayment
} from './checkout/actions';
import {
  retrieveActiveTournaments
} from './home/actions';
import {
  checkAuth,
  silentCheckAuth
} from 'shared/auth/actions';
import { handleCompletePayBalance } from './manage/actions';
import {setTournamentInState} from './actionTypes';
import { clearShared } from './shared/actionTypes';

export const handleRegistrationManageRouteEnter = (nextState, replace, callback) => (dispatch, getState) => {
  dispatch(clearShared());
  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    dispatch(loadTournament(nextState.params.tournamentId)).then(() => {
      const state = getState();

      if (!state.registration.base.captainPassesAgeRestrictions){
        dispatch(navigateTo(`registration`));
      }
    });
    dispatch(setSubTitle('Manage Registration'));
    dispatch(retrieveEntries(nextState.params.tournamentId));
    dispatch(retrieveUserVirtualEntries(nextState.params.tournamentId));
    dispatch(retrieveCountries());
    dispatch(retrieveStates());

    const paymentId = nextState.params.paymentId;

    const paymentData = {
      BypassWebHooks: localStorage.bypassWebHooks,
      PaymentId: paymentId
    };

    if (paymentId) {
      dispatch(handleCompletePayBalance(nextState.params.tournamentId, paymentData));
    }
  })
  .catch(() => {});
};

export const handleRegistrationCheckoutRouteEnter = (nextState, replace, callback) => dispatch => {
  if (detectIE() && JSON.parse(localStorage.forceRefresh || false)) {
    localStorage.forceRefresh = false;
    window.location.reload();
  }

  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    dispatch(loadTournament(nextState.params.tournamentId))
    .then(() => {
      dispatch(restoreLocalDataForCheckout())
      .then(() => {
        dispatch(validateCart());
      });

      const paymentDetail={
        PaymentId:nextState.params.paymentId,
        TournamentId: nextState.params.tournamentId
      };
  
      if(paymentDetail.PaymentId){
        dispatch(processPayment(paymentDetail));
      }

    });
    dispatch(setSubTitle('Checkout'));
    dispatch(retrieveTermsUrl(nextState.params.tournamentId));
    dispatch(resetAgreeToTerms());
    dispatch(resetValidationMesssages());

  })
  .catch(() => {});
};

export const handleRegistrationScheduleRouteEnter = (nextState, replace, callback) => (dispatch, getState) => new Promise((resolve, reject) => {
  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    dispatch(checkRestrictions(nextState.params.tournamentId))
    .then(() => {
      dispatch(setSubTitle('Schedule'));

      const reg = getState().registration;
      const isReturning = reg.base.returningToCalendar;

      // TODO: simple tournamentId validation fix (but returningToCalendar is likely not getting reset when it should)
      if (isReturning && reg.scheduler.calendar.selectedDate && reg.base.tournamentId === nextState.params.tournamentId) {
        dispatch(updateTotalFromLocalStorage());
        dispatch(handleDateSelection(reg.scheduler.calendar.selectedDate)); 
      } else {
        dispatch(loadTournament(nextState.params.tournamentId))
        .then(() => {
          dispatch(updateTotalFromLocalStorage());
        });
        dispatch(retrieveAvailableDates(nextState.params.tournamentId)).then(() => {});
        dispatch(retrieveVirtualEvents(nextState.params.tournamentId));
        dispatch(resetInformation());
      }
    })
    .catch(error => {
      if (error != 'MinimumCaptainAgeFailed' && 
          error != 'MissingRequiredProfileFields'&& 
          error != 'NeedToConfirmProfile'){
        reject(error);
      }
    });
  });
});

export const handleAccountCreatedRouteEnter = (nextState, replace, callback) => (dispatch, getState) => {
  dispatch(silentCheckAuth(nextState, replace, callback))
  .then(() => {
    let state = getState();
    
    if (!state.shared.auth.email || state.shared.auth.profileIsConfirmed)
    {
      dispatch(navigateTo(`registration`));
      return;
    }

    dispatch(displayGoHome(false));
    setTimeout(function(){
      dispatch(displayGoHome(true));
    }, 10000);

    dispatch(setTitle('Event Registration'));
    dispatch(setSubTitle('')); 
  });
};

export const handleRegistrationHomeRouteEnter = (nextState, replace, callback) => (dispatch, getState) => {
  dispatch(silentCheckAuth(nextState, replace, callback))
  .then(() => {
    let state = getState();
  
    if (!!state.shared.auth.email && 
      !state.shared.auth.profileIsConfirmed && 
      state.shared.auth.profileIsWorking)
    {
      dispatch(navigateTo(`registration/accountCreated`));
      return;
    }
    
    if (!state.shared.auth.maintenanceMessage) {
      processTags(nextState);
      dispatch(retrieveActiveTournaments(nextState.location.query));
    }

    dispatch(setTitle('Event Registration'));
    dispatch(setSubTitle(''));
  });
};

export const handleRegistrationCheckoutRosterRouteEnter = (nextState, replace, callback) => dispatch => {
  dispatch(clearShared());
  if (detectIE() && JSON.parse(localStorage.forceRefresh || false)) {
    localStorage.forceRefresh = false;
    window.location.reload();
  }

  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    dispatch(loadTournament(nextState.params.tournamentId))
    .then(() => {
      dispatch(restoreLocalDataForCheckout())
      .then(() => {
        dispatch(retrieveEvents(nextState.params.tournamentId))
        .then(() => {
          dispatch(retrieveEntriesFromCart())
          .then(() => {
            dispatch(retrieveVirtualEntriesFromCart());
            dispatch(validateCart());
          });
        });
      });
    });
    
    dispatch(setSubTitle('Roster'));
    dispatch(retrieveUserVirtualEntries(nextState.params.tournamentId));
    dispatch(retrieveCountries());
    dispatch(retrieveStates());
  })
  .catch(() => {});
};

export const loadTournament = id => dispatch => new Promise((resolve, reject) => {
  dispatch(setTitle(''));
  dispatch(getJsonAsync(`registration/tournament/${id}`))
  .then(tournament => {
    dispatch(verifyCartState(id));
    dispatch(setTournamentInState(tournament));
    dispatch(setTitle(tournament.name));
    dispatch(setTopBannerImagePath(tournament.customImageLargePath));
    resolve(tournament);
  })
  .catch(error => reject(error));
});

export const verifyCartState = tournamentId => () => {
  const cart = getShoppingCart();

  // clear registration cart when navigating to another tournament
  if(tournamentId !== cart.tournamentId) {
    delete localStorage.cart;
  }
};

export const getShoppingCart = () => {
  const cart = JSON.parse(localStorage.cart || null) || {};

  return {
    ...cart,
    squads: cart.squads || [],
    virtualEvents: cart.virtualEvents || []
  };
};

export const setShoppingCart = (updatedCart, tournamentId) => () => {
  updatedCart.tournamentId = tournamentId;
  localStorage.cart = JSON.stringify(updatedCart);
};

const processTags = (nextState) => {
  let keys = Object.keys(nextState.location.query);
  let tagsPresent = false;
  let tags = '';

  keys.forEach(key => {
    if (key.toLowerCase() == 'tags') {
      tagsPresent = true;
      tags = nextState.location.query[key];
    }
  });

  if (!tagsPresent) {
    if (localStorage.tags) {
      nextState.location.query.tags = localStorage.tags;

      if (history && history.replaceState) {
        history.replaceState(history.state, null, `${window.location.href}?tags=${nextState.location.query.tags}`);
      }
    }
  }
  else {
    nextState.location.query.tags = tags;
    
    localStorage.tags = nextState.location.query.tags;
  }
};



// WEBPACK FOOTER //
// ./src/features/registration/actions.js